import React, { FC } from 'react';

export interface SnowflakeProps {
  size?: number;
  color: string;
  className?: string;
  style?: React.CSSProperties;
}

const ARM = 'M12 12V3M12 6l-2-2M12 6l2-2M12 9.5l-2-2M12 9.5l2-2';
const ARM_ANGLES = [0, 60, 120, 180, 240, 300];

/** A six-armed snowflake used for the falling-snow animations. */
export const Snowflake: FC<SnowflakeProps> = ({ size = 18, color, className, style }) => (
  <svg
    className={className}
    style={style}
    width={size}
    height={size}
    viewBox='0 0 24 24'
    aria-hidden='true'
    data-testid='Snowflake'>
    <g stroke={color} strokeWidth='1.6' strokeLinecap='round' fill='none'>
      {ARM_ANGLES.map((angle) => (
        <path key={angle} d={ARM} transform={`rotate(${angle} 12 12)`} />
      ))}
    </g>
    <circle cx='12' cy='12' r='1.4' fill={color} />
  </svg>
);

export default Snowflake;
